import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { fadeInAnimation } from '../../../animations';
import * as fromRoot from '../../../core/store';
import { Place } from '../../../core/interfaces/place.interface';
import * as actions from '../../../core/store/stock/stock.actions';
import { Stock } from '../../../core/store/stock/stock.interface';
import { BaseContainer } from '../../base/BaseContainer';
import { distinctUntilChanged, map, takeWhile } from 'rxjs/operators';

@Component({
  selector: 'app-report-page',
  templateUrl: './report-page.container.html',
  styleUrls: ['./report-page.container.scss'],
  animations: [fadeInAnimation],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportPageContainer extends BaseContainer {
  //tabs
  selectedTab: number = 0;

  locations: Place[] = [];
  location: Place;
  places: { [key: string]: Place };

  stock: Stock;
  totalItems: number;
  isLoading: boolean = false;

  constructor() {
    super();

    this.store
      .pipe(
        takeWhile(() => !this.destroyed),
        map(state => state.customerInfo),
        distinctUntilChanged()
      )
      .subscribe(customerInfo => {
        const places = (customerInfo.customer && customerInfo.customer.shipTos) || [];
        if (places) {
          this.locations = places.map(place => {
            return {
              id: place.id,
              name: place.name,
            };
          });
        }
      });

    this.store
      .select('stock')
      .pipe(takeWhile(() => !this.destroyed))
      .subscribe((stock: Stock) => {
        this.stock = stock;
        this.totalItems = stock.totalItems;
        this.isLoading = stock.loading;
        this.location = stock.location;
      });
  }

  filterStock({ value }) {
    this.store.dispatch(new actions.StockLoadAction({ filter: value }));
  }
}
